<mat-toolbar>
        <div class="link-elocky">
            <a href="https://elocky.com">
             <span>elocky.com</span>
            </a>
        </div>
</mat-toolbar>